<template>
  <div class="hello flex">
    <div class="left">
      <centerleft></centerleft>
    </div>
    <div class="right">
      <div class="head1">
        意见反馈
      </div>
      <div class="main1">
        <h3>问题描述</h3>
       <el-input style="margin-left: 40px;width: 800px;"
         type="textarea"
         :rows="8"
         placeholder="请填写你的问题或建议，感谢你的支持~（最多可输入200字）"
         v-model="textarea">
       </el-input>
        <h3>图片上传</h3>
      <el-upload style="margin-left: 40px;"
        class="upload-demo"
        drag
        action="https://jsonplaceholder.typicode.com/posts/"
        multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
  import centerleft from '../../components/me/centerleft.vue'
  export default {
    data() {
      return {
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value: ''
      }
    },
    components:{
      centerleft
    },
    created() {

    },
    methods:{
      goUrl(url){
         this.$router.push({
         		path: url
         })
      }
    }
  }
</script>

<style scoped lang="scss">
   .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

  .schoolList {
    margin: 40px 0;
  }
  .caozuo {
    text-align: left;

    button {
      width: 58px;
      height: 36px;
      border: none;
      border-radius: 4px;
    }

    & button:nth-child(1) {
      background: #19CACA;
      color: #FFFFFF;
      margin-right: 30px;
    }

    & button:nth-child(2) {
      background: #F0F1F6;
      color: #ACABB9;
    }
  }

  .main1 {
    margin: 0 15px 0 15px;
    text-align: left;
    span {
      width: 100px;
    }
    h3{
      margin: 46px 0 16px 42px;font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
    }
    .one {
      text-align: left;
      margin: 20px 0;
      justify-content: space-between;
    }

    .one1 {
      text-align: left;
      margin: 20px 0;
    }
  }

  .headImg {
    width: 70px;
    height: 70px;
    vertical-align: middle;
  }

  .head1 {
    width: 100%;
    height: 54px;
    background: #FAFAFA;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 54px;
    text-align: left;
    text-indent: 25px;
  }

  .right {
    width: 893px;
    height: 959px;
    border: 1px solid #EDEDED;
    border-radius: 4px;
    margin-left: 24px;
  }

  .left {
    width: 283px;
    height: 692px;
    border: 1px solid #EDEDED;
    border-radius: 4px;

    .tixian {
      width: 70px;
      height: 32px;
      background: #19CACA;
      border-radius: 4px;
      border: none;
      color: #FFFFFF;
    }

    .line2 {
      margin: 45px 32px 25px 32px;
      justify-content: space-between;

      span {
        color: #F9D681;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #F9D681;
      }
    }

    .line1 {
      margin-top: 27px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;

      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        margin-right: 11px;
      }
    }
  }

  .hello {
    width: 1300px;
    margin: 40px auto;
    align-items: flex-start;
  }

  .el-menu-vertical-demo {
    text-align: left !important;
  }
  .schoolList {
    margin: 40px 0;
    .one {
      .info1 {
        margin-left: 68px;

        img {
          width: 20px;
          height: 20px;
          margin-top: 16px;
        }
      }

      text-align: left;
      border-bottom: 1px solid #F2F2F2;
      padding-bottom: 37px;
      margin-top: 30px;

      button {
        width: 74px;
        height: 32px;
        background: #19CACA;
        border-radius: 4px;
        border: none;
        font-weight: 400;
        color: #FFFFFF;
        margin-left: 240px;
      }

      img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
        margin-right: 12px;
      }

      .type {
        margin-top: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }

      .name {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 29px;
      }

      .address {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/me/feedback.vue